import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4096a572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " すべてのワードが表示されません。描写サイズを上げるか最大フォントサイズを下げてください。 ", -1))
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab_content",
  id: "tab2_2_content"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab_content_description" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-txtsp" }, "積み上げ 棒グラフ")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"font-size":"20px"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["data-src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab_content",
  id: "tab2_content"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab_content_description" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-txtsp" }, "棒グラフ")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab_content",
  id: "tab1_content"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab_content_description" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "c-txtsp" }, "円グラフ")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "tab1_canvas",
    style: {"height":"60vh"}
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["src"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "最小", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "最大", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "高さ⇳", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "幅⬄", -1))
const _hoisted_38 = {
  id: "wordcloud",
  ref: "capture"
}
const _hoisted_39 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_pane = _resolveComponent("pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_lightgallery = _resolveComponent("lightgallery")!
  const _component_splitpanes = _resolveComponent("splitpanes")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "メッセージ",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 閉じる ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.activeName) = $event)),
      class: "demo-tabs",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "積み上げ 棒グラフ",
          name: "third"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_splitpanes, { class: "default-theme" }, {
              default: _withCtx(() => [
                _createVNode(_component_pane, {
                  "min-size": "20",
                  height: "400"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.copyBarChartGraph,
                          icon: "CopyDocument"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("コピー")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_pane, null, {
                  default: _withCtx(() => [
                    (_ctx.isVisibleBarTable || _ctx.isVisibleBarImages)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.selectedBarText), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isVisibleBarTable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _ctx.copyBarTable,
                                icon: "CopyDocument"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("コピー")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _hoisted_8,
                          _createVNode(_component_el_table, {
                            ref: "barTable",
                            data: _ctx.tableData,
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "type",
                                label: "ふせんの形",
                                width: "100px"
                              }),
                              _createVNode(_component_el_table_column, { label: "内容" }, {
                                default: _withCtx((scope) => [
                                  (/https/.test(scope.row.text))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        style: {"width":"90px","height":"90px"},
                                        src: scope.row.text
                                      }, null, 8, _hoisted_9))
                                    : _createCommentVNode("", true),
                                  (!/https/.test(scope.text))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.text), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isVisibleBarImages)
                      ? (_openBlock(), _createBlock(_component_lightgallery, {
                          key: 2,
                          settings: {
                  speed: 500,
                  showZoomInOutIcons: true,
                  actualSize: false,
                  plugins: _ctx.plugins,
                  licenseKey: _ctx.licenseKey,
                },
                          onInit: _ctx.onlgInit
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (data, index) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: index,
                                className: "gallery-item",
                                "data-src": data.text
                              }, [
                                _createElementVNode("img", {
                                  src: data.text,
                                  class: "image",
                                  style: {"width":"30%"}
                                }, null, 8, _hoisted_12)
                              ], 8, _hoisted_11))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["settings", "onInit"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "棒グラフ",
          name: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.copyBarChart2Graph,
                  icon: "CopyDocument"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("コピー")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "円グラフ",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.copyPieChartGraph,
                  icon: "CopyDocument"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("コピー")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "表",
          name: "fourth"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.copyTable,
                  icon: "CopyDocument"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("コピー")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _hoisted_15,
            _createVNode(_component_el_table, {
              id: "elTable",
              data: _ctx.transTableData,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "赤",
                  "label-class-name": "label-red"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[0]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[0],
                          class: "tableImage"
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[0]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(scope.row[0]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "紫",
                  "label-class-name": "label-purple"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[1]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[1],
                          class: "tableImage"
                        }, null, 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[1]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row[1]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "青",
                  "label-class-name": "label-blue"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[2]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[2],
                          class: "tableImage"
                        }, null, 8, _hoisted_20))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[2]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(scope.row[2]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "緑",
                  "label-class-name": "label-green"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[3]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[3],
                          class: "tableImage"
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[3]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row[3]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "黄",
                  "label-class-name": "label-yellow"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[4]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[4],
                          class: "tableImage"
                        }, null, 8, _hoisted_24))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[4]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(scope.row[4]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "薄い灰色",
                  "label-class-name": "label-lightgray"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[5]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[5],
                          class: "tableImage"
                        }, null, 8, _hoisted_26))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[5]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(scope.row[5]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "灰色",
                  "label-class-name": "label-gray"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[6]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[6],
                          class: "tableImage"
                        }, null, 8, _hoisted_28))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[6]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(scope.row[6]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "オレンジ",
                  "label-class-name": "label-orange"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[7]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[7],
                          class: "tableImage"
                        }, null, 8, _hoisted_30))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[7]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(scope.row[7]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "ピンク",
                  "label-class-name": "label-pink"
                }, {
                  default: _withCtx((scope) => [
                    (/https/.test(scope.row[8]))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"auto","height":"90px"},
                          src: scope.row[8],
                          class: "tableImage"
                        }, null, 8, _hoisted_32))
                      : _createCommentVNode("", true),
                    (!/https/.test(scope.row[8]))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(scope.row[8]), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "ワードクラウド(ベータ)",
          name: "tabWordCloud"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_splitpanes, { class: "default-theme" }, {
              default: _withCtx(() => [
                _createVNode(_component_pane, {
                  "min-size": "20",
                  size: "65",
                  height: "400"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      model: _ctx.wordform,
                      "label-width": "120px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "集計方法" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _ctx.wordform.shukei,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wordform.shukei) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_button, {
                                  type: "info",
                                  label: "1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("品詞分解")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio_button, {
                                  type: "info",
                                  label: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("ふせん一行")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "ふせん色" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "info",
                                  onClick: _ctx.selectAllColor
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("すべて選択")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 21,
                              class: "left-align"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: _ctx.wordform.colors,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wordform.colors) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("赤")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("紫")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("青")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("緑")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("黄")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("薄い灰色")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "7"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("灰色")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "8"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("オレンジ")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "9"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("ピンク")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "品詞" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_link, {
                                  type: "info",
                                  onClick: _ctx.selectAllClass
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("すべて選択")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 21,
                              class: "left-align"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: _ctx.wordform.class,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.wordform.class) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("名詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("動詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("副詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("形容詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("連体詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("感動詞")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_checkbox_button, {
                                      type: "info",
                                      label: "7"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("数")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "最小表示数" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.wordform.minCount,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.wordform.minCount) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "1個",
                                  value: "1"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "2個",
                                  value: "2"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "3個",
                                  value: "3"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "4個",
                                  value: "4"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "5個",
                                  value: "5"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "キーワード1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.wordform.keyword1,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.wordform.keyword1) = $event)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "キーワード2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.wordform.keyword2,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.wordform.keyword2) = $event)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "キーワード3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.wordform.keyword3,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.wordform.keyword3) = $event)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "キーワード4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.wordform.keyword4,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.wordform.keyword4) = $event)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "キーワード5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.wordform.keyword5,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wordform.keyword5) = $event)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "フォントサイズ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 2,
                              class: "text-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.wordform.minFontSize,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.wordform.minFontSize) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "6px",
                                      value: "6"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "7px",
                                      value: "7"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "8px",
                                      value: "8"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "9px",
                                      value: "9"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "10px",
                                      value: "10"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "11px",
                                      value: "11"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "12px",
                                      value: "12"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 2,
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_35
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.wordform.maxFontSize,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.wordform.maxFontSize) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "32px",
                                      value: "32"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "48px",
                                      value: "48"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "64px",
                                      value: "64"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "80px",
                                      value: "80"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "画像サイズ" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 2,
                              class: "text-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.wordform.imgHeight,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.wordform.imgHeight) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "100px",
                                      value: "100"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "200px",
                                      value: "200"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "300px",
                                      value: "300"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "400px",
                                      value: "400"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "500px",
                                      value: "500"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "600px",
                                      value: "600"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "700px",
                                      value: "700"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "800px",
                                      value: "800"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "900px",
                                      value: "900"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1000px",
                                      value: "1000"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1100px",
                                      value: "1100"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1200px",
                                      value: "1200"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, {
                              span: 2,
                              class: "text-right"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 4 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.wordform.imgWidth,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.wordform.imgWidth) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "100px",
                                      value: "100"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "200px",
                                      value: "200"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "300px",
                                      value: "300"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "400px",
                                      value: "400"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "500px",
                                      value: "500"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "600px",
                                      value: "600"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "700px",
                                      value: "700"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "800px",
                                      value: "800"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "900px",
                                      value: "900"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1000px",
                                      value: "1000"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1100px",
                                      value: "1100"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "1200px",
                                      value: "1200"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.kuromojiParse
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("作成")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_pane, {
                  size: "35",
                  "max-size": "35",
                  "min-size": "35"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_38, null, 512),
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        settings: {
                  speed: 500,
                  showZoomInOutIcons: true,
                  actualSize: false,
                  plugins: _ctx.plugins,
                  licenseKey: _ctx.licenseKey,
                },
                        onInit: _ctx.onlgInit2
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.dataURL,
                            style: {"width":"100%"}
                          }, null, 8, _hoisted_39)
                        ]),
                        _: 1
                      }, 8, ["settings", "onInit"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])
  ]))
}